import {isNotNilOrEmpty} from 'ramda-adjunct';

import {OrderDiscriminator, OrderPaymentResponseBody, OrderResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

/**
 * Orders whose payments can carry a supplier invoice number. Mirrors the condition that decides
 * where the field is offered in the checkout payment form.
 */
const PURCHASE_ORDER_DISCRIMINATORS: OrderDiscriminator[] = ['PURCHASE', 'PURCHASE_BROKERAGE_SALE'];

type CheckoutWithPurchasePayments = {
  orders: (Pick<OrderResponseBody, 'orderDiscriminator'> & {
    payments: Pick<OrderPaymentResponseBody, 'supplierInvoiceNumber'>[];
  })[];
};

/**
 * Takes the first supplier invoice number a purchase payment carries, in the order the API returns
 * them, regardless of the payment's state. A checkout can hold several purchase payments and nothing
 * in the response ranks them, so there is no precedence to honour - the value only seeds an editable
 * form field, and whatever the user leaves in it is what gets submitted.
 */
export const getSupplierInvoiceNumberFromCheckout = (
  checkout: CheckoutWithPurchasePayments | Nullish
) =>
  checkout?.orders
    .filter((order) => PURCHASE_ORDER_DISCRIMINATORS.includes(order.orderDiscriminator))
    .flatMap((order) => order.payments)
    .map((payment) => payment.supplierInvoiceNumber)
    .find(isNotNilOrEmpty) ?? null;
